import * as Yup from "yup";

// ITIN format: 9XX-XX-XXXX (starts with 9)
// SSN format: XXX-XX-XXXX (cannot start with 000, 666, or 900-999)
const ssnItinRegex =
  /^(?!999[-]?99[-]?9999$)(?:(?!000|666)\d{3}|9\d{2})[-]?\d{2}[-]?\d{4}$/;

export const validatorSsnItin = Yup.string().test(
  "ssnOrItin",
  "Please enter a valid 9-digit SSN or ITIN",
  value => {
    if (!value || value.length === 0) return true; // Optional field

    // Remove any non-digit characters for length check
    const digitsOnly = value.replace(/\D/g, "");

    // Must be exactly 9 digits
    if (digitsOnly.length !== 9) {
      return false;
    }

    // Test against the combined regex
    return ssnItinRegex.test(value);
  }
);
